import React, { useState, useEffect } from "react";
import { Card, Typography } from "antd";

const { Title } = Typography;

const InvestorDescription = ({ data, animationPreview, recommendationLabels }) => {
  const [displayText, setDisplayText] = useState("");
  const [isTyping, setIsTyping] = useState(true);
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    setDisplayText("");
    setCurrentIndex(0);
    setIsTyping(true);
  }, [data?.ai_description]);

  useEffect(() => {
    if (!data?.ai_description) {
      setDisplayText("");
      setCurrentIndex(0);
      return;
    }
    if (!animationPreview) {
      setDisplayText(data?.ai_description || "");
      setCurrentIndex(0);
      setIsTyping(false);
      return;
    }
    if (isTyping && currentIndex < data?.ai_description?.length) {
      const timeout = setTimeout(() => {
        setDisplayText((prev) => prev + data.ai_description[currentIndex]);
        setCurrentIndex((prev) => prev + 1);
      }, 20); // Adjust speed as needed

      return () => clearTimeout(timeout);
    } else if (currentIndex >= data?.ai_description?.length) {
      setIsTyping(false);
    }
  }, [data, currentIndex, isTyping, animationPreview]);

  useEffect(() => {
    setCurrentIndex(0);
  }, [data?.ai_description]);

  // Function to skip animation and show full text
  const handleSkipAnimation = () => {
    setDisplayText(data?.ai_description || "");
    setCurrentIndex(data?.ai_description?.length || 0);
    setIsTyping(false);
  };

  return (
    <React.Fragment>
      <div className="ai-reasons-for-target">
        <Title level={3} className="ai-reason-title">
          Reasons For Target
          <span className="ai-generated-chip">AI generated</span>
        </Title>
        <p className="ai-reason-subtitle">
          Florence-generated explanation for the selected recommendation.
        </p>
        <div className="ai-description-card">
          {isTyping && animationPreview && (
            <button className="ai-description-skip-btn" onClick={handleSkipAnimation}>
              Skip
            </button>
          )}
          <p className="ai-description-content">
            {displayText || "No AI explanation is available for this recommendation yet."}
          </p>
        </div>
      </div>
    </React.Fragment>
  );
};

export default InvestorDescription;
